import { render, staticRenderFns } from "./CourseHandout.vue?vue&type=template&id=0dc9281a&"
import script from "./CourseHandout.vue?vue&type=script&lang=js&"
export * from "./CourseHandout.vue?vue&type=script&lang=js&"
import style0 from "./CourseHandout.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports